import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const vueRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
        meta: {
          title: 'Home',
        },
    },
    
    {
        path: '*',
        component: Home
    },
  ],
  scrollBehavior () {
  // scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

vueRouter.beforeEach((to, from, next) => {
  /* It will change the title when the router is change*/
  if (to.meta.title) {
    document.title = `${to.meta.title} — Blastronaut`;
  } else {
    document.title = 'Blastronaut';
  }
  next();
})

export default vueRouter